import React, { useState } from "react";
import { Input, Select, Form } from "antd";
import LoadableButton from "../../components/button/LoadableButton";
import { SavePaymentGatewayApi } from "../../api/request/settings";
import toast from "react-hot-toast";

const Settings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        ...values,
        is_superadmin: 1,
      };
      const { data } = await SavePaymentGatewayApi(payload);
      if (data?.status){
        toast.success(data?.message || "Payment gateway saved successfully");
        form.resetFields();
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="border bg-White rounded-xl p-4 w-1/2">
      <p className="font-semibold text-lg border-b pb-3">
        Edit Payment Details
      </p>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="mt-4 space-y-4"
      >
        <Form.Item
          label={<p className="font-medium">Payment Type</p>}
          name="type"
          rules={[{ required: true, message: "Please select payment type" }]}
        >
          <Select
            size="large"
            placeholder="Select payment type"
            options={[{ value: "stripe", label: "Stripe" }]}
          />
        </Form.Item>

        <Form.Item
          label={<p className="font-medium">Secret Key</p>}
          name="secret_key"
          rules={[{ required: true, message: "Please enter secret key" }]}
        >
          <Input size="large" placeholder="Enter secret key" />
        </Form.Item>

        <Form.Item
          label={<p className="font-medium">Publish Key</p>}
          name="api_key"
          rules={[{ required: true, message: "Please Publish API key" }]}
        >
          <Input size="large" placeholder="Enter Publish key" />
        </Form.Item>

        <div className="pt-2">
          <LoadableButton
            lable="Update Payment Details"
            // className="w-full"
            type="submit"
            isLoading={isLoading}
          />
        </div>
      </Form>
    </div>
  );
};

export default Settings;
